import React from "react";
import {observer} from "mobx-react-lite"

import {MobileRectangleTableLeft} from "./rectangleTableLeft";
import {MobileRectangleTableRight} from "./rectangleTableRight";
import {MobileRectangleTableCenter} from "./rectangleTableCenter";

export const MobileRectangleTableTop = ({
                                          selectedData,
                                          memoAllChipsTypes,
                                          ovalTableBetState,
                                          handleGetColumnChip,
                                          winNumber,
                                        }) => {
  return (
    <div className="mob-roulette-t-right">
      <MobileRectangleTableLeft
        winNumber={winNumber}
        selectedData={selectedData}
        allChipsTypes={memoAllChipsTypes}
        ovalTableBetState={ovalTableBetState}
        handleGetColumnChip={handleGetColumnChip}
      />
      <MobileRectangleTableCenter
        winNumber={winNumber}
        selectedData={selectedData}
        allChipsTypes={memoAllChipsTypes}
        ovalTableBetState={ovalTableBetState}
        handleGetColumnChip={handleGetColumnChip}
      />
      <MobileRectangleTableRight
        selectedData={selectedData}
        allChipsTypes={memoAllChipsTypes}
        handleGetColumnChip={handleGetColumnChip}
      />
    </div>
  )
};
